import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import ProjectListItem from '@/views/project-forum/components/ProjectListItem.vue';
import useProfileState from '@/state/profile/profileState';
import { ProfileStoreKey } from '@/models/Profile';
import BCXPaginatedContent from '@/components/molecules/BCXPaginatedContent.vue';
import ProfileCreateProjectLink from '@/views/profile/components/views/ProfileCreateProjectLink.vue';
import useResponsiveness from '@/mixins/useResponsiveness';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfilePublicProjectsView',
  emits: ['close'],
  setup(__props, { emit }) {



const { profile, isQuickInfo } = useProfileState(ProfileStoreKey.PROFILE);
const { isSmartphoneWidth } = useResponsiveness();

const getTimestamp = (dateString?: string) => {
  if (!dateString) return 0;
  const timestamp = new Date(dateString).getTime();
  return Number.isNaN(timestamp) ? 0 : timestamp;
};

const getStatusSortValue = (status?: string) => (status === 'CLOSED' ? 1 : 0);

const projects = computed(() => [...(profile.value?.company?.publicProjects?.externalProjectList ?? [])]
  .sort((a, b) => {
    const statusSortDiff = getStatusSortValue(a.status) - getStatusSortValue(b.status);
    if (statusSortDiff !== 0) return statusSortDiff;

    const aTimestamp = getTimestamp(a.lastUpdated) || getTimestamp(a.created);
    const bTimestamp = getTimestamp(b.lastUpdated) || getTimestamp(b.created);
    return bTimestamp - aTimestamp;
  }));

const onClickProject = () => {
  if (isSmartphoneWidth.value) emit('close');
};

return { __sfc: true,emit, profile, isQuickInfo, isSmartphoneWidth, getTimestamp, getStatusSortValue, projects, onClickProject, ProjectListItem, BCXPaginatedContent, ProfileCreateProjectLink }
}

})